/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ContentLoader from 'react-content-loader'
import { navigate } from '@reach/router'

import { PropertyCard, Pagination, NotFoundCard } from 'components'
import { AlertCardContainer } from 'containers'
import { useList, useFilter } from 'store'
import { setListPropertySlug } from 'utils/propertyUrl'
import { isQueryLocationSynced, scrollToItem } from './utils'

import styles from './EstateListContainer.module.scss'

const EstateListContainer = ({ urlParams }) => {
  const { fetchList, getListData, isListLoading, clearList } = useList()
  const {
    $filter,
    $filter: { openModal },
    setFilterAndUpdateQuery,
    setFilterByUrlParams,
    getFilterUrl,
    clearFilters,
    goToFirstPage,
    setFiltersModal,
  } = useFilter()

  // check if the data must be fetched or not
  const [fetchData, setFetchData] = useState(!window.location.search)
  const [previousQuery, setPreviousQuery] = useState()
  const [previousPage, setPreviousPage] = useState(1)

  const { list, pagination } = getListData()
  const { page, max_pages } = pagination

  const listLoading = isListLoading()

  useEffect(() => {
    return () => {
      clearList()
      clearFilters()
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setFilterByUrlParams(urlParams)
    // eslint-disable-next-line
  }, [urlParams.slug, urlParams.discount, urlParams.search])

  useEffect(() => {
    window.history.replaceState('busca', 'Title', getFilterUrl())
    const makeRequest = async () => {
      await fetchList($filter.query)
      scrollToItem()
    }
    const updated =
      (!previousQuery && !!$filter.query) || $filter.query !== previousQuery

    const isLocationSynced = isQueryLocationSynced(
      $filter.query,
      $filter.selectedLocalities
    )

    if (
      updated &&
      (!$filter.initialFilters || $filter.cleared) &&
      $filter.localities.length > 1 &&
      // previousPage === $filter.page &&
      isLocationSynced
    ) {
      if (fetchData) {
        setPreviousQuery($filter.query)
        makeRequest()
      } else {
        setFetchData(true)
      }
    }

    if (
      updated &&
      previousPage !== $filter.page &&
      $filter.localities.length > 1
    ) {
      makeRequest()
      setPreviousPage($filter.page)
      setPreviousQuery($filter.query)
    } else if (updated && previousPage === $filter.page && previousQuery) {
      goToFirstPage()
    }
    // eslint-disable-next-line
  }, [$filter.query, fetchData, $filter.localities, $filter.selectedLocalities])

  const isBrowser = () => typeof window !== 'undefined'

  const widthScreen = isBrowser ? window.innerWidth : 1024

  const handlerLoader = i => {
    if (widthScreen < 400) {
      return i * 10
    }
    if (widthScreen > 1024) {
      return i * 100 - 100
    }

    return i * 500 - 490
  }

  const placeholder = (
    <ContentLoader
      height={widthScreen > 1024 ? 600 : 1300}
      className={styles.loader}
    >
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => {
        return (
          <rect
            key={i}
            x="0"
            y={handlerLoader(i)}
            rx="3"
            ry="3"
            width="100%"
            height={widthScreen > 1024 ? 90 : 490}
          />
        )
      })}
    </ContentLoader>
  )

  const handlePage = ({ selected: selectedPage }) => {
    window.scrollTo(0, 0) //eslint-disable-line
    setFilterAndUpdateQuery('page', selectedPage + 1)
  }

  const uniqueList = [
    ...list
      .reduce((map, estate) => {
        map.set(estate.id, estate)
        return map
      }, new Map())
      .values(),
  ]

  return (
    <section className={styles.wrapper}>
      {!listLoading &&
        uniqueList.map(estate => (
          <div id={estate.id} key={estate.id} className={styles.container}>
            <PropertyCard
              navigateRouter={`/imovel/${setListPropertySlug(estate)}`}
              immobile={estate}
              onClick={() => {
                window.scrollTo(0, 0)
                navigate(`/imovel/${setListPropertySlug(estate)}}`)
              }}
            />
            {estate.alertCard && <AlertCardContainer onClick={() => {}} />}
          </div>
        ))}
      {listLoading && placeholder}
      {!listLoading && !list.length && (
        <>
          <NotFoundCard
            openFilterModal={() => setFiltersModal('openModal', !openModal)}
          />
        </>
      )}
      {!listLoading && !!list.length && (
        <Pagination
          handleClick={handlePage}
          totalPages={max_pages}
          forcePage={page - 1}
        />
      )}
    </section>
  )
}

EstateListContainer.propTypes = {
  urlParams: PropTypes.shape({
    search: PropTypes.string,
    slug: PropTypes.string,
    discount: PropTypes.string,
  }).isRequired,
}

export default EstateListContainer
